import React from 'react';
import BaseComponent from "../../../base-component/base-component";
import { DRAFTJS_BLOCK_KEY } from './constants';

export default ({ store }) => WrappedComponent =>
    class BlockDraggableDecorator extends BaseComponent {

        // Handle start-drag and set dataTransfer data with blockKey
        startDrag = event => {
            event.dataTransfer.dropEffect = 'move'; // eslint-disable-line no-param-reassign
            // declare data and give info that its an existing key and a block needs to be moved
            event.dataTransfer.setData(
                'text',
                `${DRAFTJS_BLOCK_KEY}:${this.props.block.key}`
            );

            gd.bus.triggerEvent("dropzone:disable");
        };

        render() {
            const readOnly = store.getReadOnly ? store.getReadOnly() : true;
            return (
                <WrappedComponent {...this.props}
                                  onDragStart={!readOnly ? this.startDrag : undefined}/>
            );
        }
    };